// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"eaa5f22c","81":"61f6f545","277":"0dae52f3","453":"da5d8ad6","458":"45688fc7","640":"2c9774b1","685":"51aa06a5","841":"e7cfccff","901":"ed9fa980"}[chunkId] + ".chunk.js";
};